import {FeedbackRequest} from './feedback-items';

const DISMISSED_REQUESTS_STORAGE_PREFIX =
  'beam:feedback:dismissed-request-ids';

const storageKey = (workspaceId: string, userId: string) =>
  `${DISMISSED_REQUESTS_STORAGE_PREFIX}:${workspaceId}:${userId}`;

export const getDismissedFeedbackRequestIds = (
  workspaceId: string,
  userId: string,
): string[] => {
  if (typeof window === 'undefined') return [];

  try {
    const storedValue = window.localStorage.getItem(
      storageKey(workspaceId, userId),
    );
    if (!storedValue) return [];

    const parsedValue = JSON.parse(storedValue);
    return Array.isArray(parsedValue)
      ? parsedValue.filter(
          (value): value is string => typeof value === 'string',
        )
      : [];
  } catch {
    return [];
  }
};

export const rememberDismissedFeedbackRequest = (
  workspaceId: string,
  userId: string,
  requestId: string,
) => {
  if (typeof window === 'undefined') return;

  try {
    const dismissedIds = new Set(
      getDismissedFeedbackRequestIds(workspaceId, userId),
    );
    dismissedIds.add(requestId);
    window.localStorage.setItem(
      storageKey(workspaceId, userId),
      JSON.stringify(Array.from(dismissedIds)),
    );
  } catch {
    // Dismissal still succeeds for this session when browser storage is blocked.
  }
};

export const excludeDismissedFeedbackRequests = (
  requests: FeedbackRequest[],
  workspaceId: string,
  userId: string,
) => {
  const dismissedIds = new Set(
    getDismissedFeedbackRequestIds(workspaceId, userId),
  );

  return requests.filter(({id}) => !dismissedIds.has(id));
};
